import React, { FC, useEffect, useState } from "react";
import { heroImageWrapper } from "./styles/header-image.module.scss";
import { Box } from "designsystem";

export interface HeaderImageProps {
  alt: string;
  src: string;
  srcSet?: string;
  elevation?: "high";
}

const HeaderImage: FC<HeaderImageProps> = ({ alt, src }) => {
  const [parallaxAmount, setParallaxAmount] = useState("");

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY < window.outerHeight) {
        setParallaxAmount(`-${window.scrollY / 2}px`);
      }
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Box
      style={{
        transform: `translateY(${parallaxAmount})`
      }}
      position="absolute"
      overflow="hidden"
      className={heroImageWrapper}
    >
      <img alt={alt} src={src} />
    </Box>
  );
};

export default HeaderImage;
